export default {
  "slug": "smoke-vs-heat-detectors",
  "title": "Smoke vs Heat Detectors: How to Choose",
  "description": "Photoelectric vs ionization smoke detection, fixed-temperature vs rate-of-rise heat detection, and how to match detector technology to the space to reduce nuisance alarms.",
  "keywords": "smoke detector placement, smoke detector spacing rules NFPA 72, heat detector, detector spacing, ceiling spacing, detector selection, nuisance alarms",
  "ogImage": "/guide-og/smoke-vs-heat-detectors.jpg",
  "faqs": [
    {
      "q": "What's the difference between photoelectric and ionization smoke detectors?",
      "a": "Photoelectric sensors respond well to larger particles from smoldering fires, while ionization sensors respond to smaller particles from fast, flaming fires. Multi-criteria detectors combine methods to improve response and reject nuisance alarms."
    },
    {
      "q": "When should I use a heat detector instead of a smoke detector?",
      "a": "Use heat detection in dusty, dirty, or high-heat areas where smoke detection would cause nuisance alarms. Fixed-temperature detectors trip at a set threshold; rate-of-rise detectors respond to a rapid temperature increase."
    },
    {
      "q": "How do I reduce nuisance alarms?",
      "a": "Match the detector technology to the environment, keep detectors away from supply-air diffusers and dead-air pockets, and follow the manufacturer's spacing and listing."
    }
  ],
  "category": "Detection",
  "readMins": 5,
  "published": "2026-08-17",
  "updated": "2026-09-27",
  "hero": "https://static.prod-images.emergentagent.com/jobs/73bed830-7de9-440e-a664-81f833da5bb8/images/bc7ab3c54e6e118f46cb7cd8c2c25fe755b29ef70832173f6a9c94f23aa27f14.jpeg",
  "heroAlt": "Illustration comparing a smoke detector and a heat detector",
  "excerpt": "The right detector in the right place detects real fires faster and avoids false alarms. Here's how smoke and heat detection compare.",
  "sections": [
    {
      "h": "Smoke detection types",
      "p": "Photoelectric sensors respond well to larger particles from smoldering fires; ionization sensors respond to smaller particles from fast, flaming fires. Multi-criteria detectors combine methods to improve response and reject nuisances."
    },
    {
      "h": "Heat detection types",
      "p": "Fixed-temperature detectors activate at a set threshold; rate-of-rise detectors respond to a rapid temperature increase. Heat detection suits dusty, dirty, or high-heat areas where smoke detection would cause nuisance alarms."
    },
    {
      "h": "Matching detection to the space",
      "p": "Consider ceiling height, airflow, ambient dust and humidity, and the expected fire type. Keep detectors away from supply diffusers and dead-air pockets, and follow the manufacturer's spacing and listing."
    },
    {
      "h": "Spacing rules under NFPA 72",
      "p": "Spot-type smoke detectors have a listed spacing (often referenced around a 30-foot nominal spacing on smooth, flat ceilings) that must be reduced for high ceilings, beams, joists, sloped ceilings, and airflow. Heat detectors are spaced by their listing and temperature rating. Spacing is a starting point, not a guarantee — NFPA 72 requires adjustments for ceiling construction and airflow, and detectors must be kept away from supply diffusers that can dilute smoke before it reaches the sensor. Always verify the listed spacing and the adopted edition's adjustment rules with the AHJ."
    }
  ],
  "relatedModules": [
    "detector-tech",
    "smoke-detection",
    "heat-detection"
  ],
  "relatedGuides": [
    "fire-alarm-system-design-basics"
  ]
};
